import React, { memo } from "react"

import { imported } from "react-imported-component"
import { PrerenderedComponent } from "react-prerendered-component"

import { DynamicImportType } from "."

export function prerenderedLazy<T>(dynamicImport: DynamicImportType) {
  const LazyComponent = imported(dynamicImport, { async: true })

  return memo((props: T) => (
    <PrerenderedComponent live={LazyComponent.preload()}>
      <LazyComponent {...props} />
    </PrerenderedComponent>
  ))
}
